import { Form } from "../Support/Form";
import { Processor } from "../Procesor/Processor";
import { axios } from "../Support/axios";

export class ProductSync extends Form {

    constructor(data = {}) {
        super(data);

        this.processor = null;

        this.processors = false;
        this.sync = false;
    }

    syncAvailable() {
        return this.sync;
    }

    index() {
        let self = this;

        return new Promise((resolve, reject) => {

            let processor = new Processor();

            processor.list().then(function (result) {

                self.processors = result.data;

                axios.get('/api/product/sync', self.data)
                    .then(response => {
                        let index = response.data;

                        if (index.data.length > 0) {
                            self.sync = {
                                data: index.data[0]
                            };
                        }

                        resolve(true);
                    })
                    .catch(error => {
                        self.setError(error);
                        reject(error);
                    })
            });
        });
    }

    startSync() {
        let self = this;

        return new Promise((resolve, reject) => {

            self.sync = false;

            axios.post('/api/product/sync/' + this.processor, self.data)
                .then(response => {

                    self.sync = response.data;
                    self.processor = null;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    confirmProduct(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.post('/api/product/sync/' + id + '/confirm', self.data)
                .then(response => {
                    let index = response.data;

                    if (index.data.length > 0) {
                        self.sync = {
                            data: index.data[0]
                        };
                    }

                    resolve(true);
                })
                .catch(error => {
                    alert(error);

                    self.setError(error);
                    reject(error);
                })
        });
    }

}
